<template>
  <v-dialog :value="value" @input="(v) => $emit('input', v)" width="unset">
    <v-card class="tw-p-8">
      <v-card-title class="tw-font-bold tw-p-0">
        คุณต้องการลบ ร้านค้า{{ shop.nameTH }} ใช่ไหม
      </v-card-title>

      <v-card-actions class="tw-mt-8 tw-p-0">
        <v-spacer></v-spacer>
        <v-btn color="error" text @click="onDelete" :loading="loading">
          <img class="tw-mr-2" src="/images/icons/delete.svg" />
          ลบร้านค้า
        </v-btn>
        <v-btn
          class="tw-ml-3"
          color="primary"
          elevation="0"
          @click="$emit('input', false)"
        >
          <v-icon left>mdi-close-circle-outline</v-icon>
          ไม่ใช่
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    companyId: {
      type: String,
      required: true,
    },
    shopId: {
      type: String,
      required: true,
    },
    shop: {
      type: Object,
    }
  },
  data: () => ({
    loading: false,
  }),
  methods: {
    async onDelete() {
      this.loading = true
      try {
        await this.$store.dispatch('shops/remove', {
          companyId: this.companyId,
          shopId: this.shopId,
        })
        this.loading = false
        this.$emit('input', false)
        this.$emit('success')
      } catch (err) {
        console.error(err)
        this.loading = false
      }
    },
  }
}
</script>